module.exports = __webpack_public_path__ + "img/brand_5.3b469052.png";